import { Portal } from './portal/Portal.model';
import { Sede } from './Sede.model';
export class UserInfo {
	usr_id: number = 0;
	cli_id: number = 0;
	usr_username: string = '';
	usr_password: string = '';
	usr_firstname: string = '';
	usr_lastname: string = '';
	authorities: string = '';
	usr_displayname: string = '';
	usr_mail: string = '';
	token: string = '';
	rl_description: string = '';
	rl_id: number = 0;
	usr_primoaccesso: number = 0;
	foto: string = '';
	usr_codiceFiscale: string = '';
	usr_telefono: string = '';
	usr_phone: string = '';
	usr_language: string = '';
	portali: Portal[] = [];
	totalrows: number = 0;
	sedi: Sede[] = [];
	// Solo in creazione (wizard utente): portali e ruoli oltre al portale principale e al GUEST di default
	portal_ids: number[] = [];
	role_ids: number[] = [];
}
